// extracted by mini-css-extract-plugin
export default {"root":"CircularProgress_root__fSHIr","loadingAnimation":"CircularProgress_loadingAnimation__XxIE6"};